/**
 * Hear Control RBAC policy map (user / fono / gestor / admin).
 * Factory action keys ⊆ hear-backend 008 + `configuration.policy.edit`.
 * Overlay keys stay out of this map. MUST NOT `manager`.
 */

export const ROLE = {
  ADMIN: "admin",
  GESTOR: "gestor",
  FONO: "fono",
  /** Hear recepção/assistente. Not Lead Control `user`. */
  USER: "user",
};

/** Unknown pages = allow any active role. */
export const PAGE_POLICIES = {
  "configuracoes.html": [ROLE.ADMIN, ROLE.GESTOR],
};

/**
 * Pages gated by session-effective action keys (overlay-customizable).
 * `configuracoes.html` stays on `PAGE_POLICIES` (locked gestor+admin).
 */
export const PAGE_ACTION_POLICIES = {
  "financeiro.html": "financeiro.read",
  "precificacao.html": "financeiro.read",
  "pagamentos.html": "financeiro.read",
  "emissor_nf.html": "financeiro.read",
  "catalogo.html": "catalog.read",
  "parceiros.html": "parceiros.read",
  "atendimento.html": "registros.read",
  "painel.html": "painel.read",
  "agenda.html": "atendimentos.read",
  "audio_fono.html": "exams.read",
  "pacientes.html": "patients.read",
  "manutencao.html": "ordens_servico.read",
  "relatorios.html": "relatorios.read",
};

/** Unknown actions = deny (fail closed). Overlay MUST NOT grant `configuracoes.read`. */
export const ACTION_POLICIES = {
  "configuration.users.create": [ROLE.GESTOR, ROLE.ADMIN],
  "configuration.users.delete": [ROLE.ADMIN],
  "configuration.users.update": [ROLE.ADMIN, ROLE.GESTOR],
  "configuration.users.list": [ROLE.ADMIN, ROLE.GESTOR],
  "configuration.policy.edit": [ROLE.ADMIN],
  "configuracoes.read": [ROLE.GESTOR, ROLE.ADMIN],
  "cadastro.discounts.edit": [ROLE.ADMIN, ROLE.GESTOR],
  "cadastro.organizations.edit": [ROLE.ADMIN, ROLE.GESTOR],
  "financeiro.read": [ROLE.GESTOR, ROLE.ADMIN],
  "financeiro.write": [ROLE.GESTOR, ROLE.ADMIN],
  "catalog.read": [ROLE.USER, ROLE.FONO, ROLE.GESTOR, ROLE.ADMIN],
  "catalog.write": [ROLE.GESTOR, ROLE.ADMIN],
  "painel.read": [ROLE.USER, ROLE.FONO, ROLE.GESTOR, ROLE.ADMIN],
  "painel.notas.write": [ROLE.USER, ROLE.FONO, ROLE.ADMIN],
  "patients.read": [ROLE.USER, ROLE.FONO, ROLE.GESTOR, ROLE.ADMIN],
  "patients.write": [ROLE.USER, ROLE.FONO, ROLE.GESTOR, ROLE.ADMIN],
  "patients.historico.write": [ROLE.FONO, ROLE.ADMIN],
  "exams.read": [ROLE.USER, ROLE.FONO, ROLE.GESTOR, ROLE.ADMIN],
  "exams.write": [ROLE.USER, ROLE.FONO, ROLE.ADMIN],
  "exams.delete": [ROLE.FONO, ROLE.ADMIN],
  "documents.read": [ROLE.USER, ROLE.FONO, ROLE.GESTOR, ROLE.ADMIN],
  "documents.write": [ROLE.USER, ROLE.FONO, ROLE.ADMIN],
  "documents.delete": [ROLE.FONO, ROLE.ADMIN],
  "atendimentos.read": [ROLE.USER, ROLE.FONO, ROLE.GESTOR, ROLE.ADMIN],
  "atendimentos.write": [ROLE.USER, ROLE.FONO, ROLE.ADMIN],
  "consultas.read": [ROLE.USER, ROLE.FONO, ROLE.GESTOR, ROLE.ADMIN],
  "consultas.write": [ROLE.FONO, ROLE.ADMIN],
  "ordens_servico.read": [ROLE.USER, ROLE.FONO, ROLE.GESTOR, ROLE.ADMIN],
  "ordens_servico.write": [ROLE.FONO, ROLE.ADMIN],
  "registros.read": [ROLE.USER, ROLE.FONO, ROLE.GESTOR, ROLE.ADMIN],
  "registros.write": [ROLE.FONO, ROLE.GESTOR, ROLE.ADMIN],
  "parceiros.read": [ROLE.GESTOR, ROLE.ADMIN],
  "parceiros.write": [ROLE.GESTOR, ROLE.ADMIN],
  "relatorios.read": [ROLE.GESTOR, ROLE.ADMIN],
  "relatorios.write": [ROLE.ADMIN],
};

export const PermissionPolicy = Object.freeze({
  ROLE,
  PAGE_POLICIES,
  PAGE_ACTION_POLICIES,
  ACTION_POLICIES,
});
